export enum ProgressTabEnum {
    ProgressTracker = "Progress Tracker",
    ReflectiveLog = "Reflective Log"
  }